<template>
    <Row v-if="ready" :even="row.even()" :backgroundColour="row.even() ? 'rowEven' : 'rowOdd'"> 
        <Column :width="15" :key="redraw">
            <Box>
                <Row>
                    <Column :width="5">
                        <Box >
                            <CheckboxUpdateCell 
                            :data="featureBox().data"
                            v-on:withValue="withValue" />
                        </Box>
                    </Column>
                    <Column :width="1"></Column>
                    <Column :width="7" v-if="!feature.isNew()">
                        <Box>
                            <StringUpdateCell 
                            :data="priceRow().data" 
                            v-on:withValue="withValue"/>
                        </Box>
                    </Column>
                </Row>
                <Row v-if="!feature.isNew()">
                    <Column :width="6"></Column>
                    <Column :width="9" :key="redrawHint">
                        <Box>
                            <StringDisplayCell
                                :data="hintRow().data"
                                />
                        </Box>
                    </Column>
                </Row>
            </Box>
        </Column>
    </Row>
</template>

<script>

import { mapActions, mapGetters } from 'vuex';

import ConnectionUtils from '@/utils/ConnectionUtils.js';
import ConstUtils from '@/utils/ConstUtils.js';
import ContentUtils from '@/utils/ContentUtils.js';
import StringUtils from '@/utils/StringUtils.js';

import MC from "@/domain/session/MC.js";

import Box from "@/portals/shared/library/box/Box.vue";
import Column from "@/portals/shared/library/box/Column.vue";
import Row from "@/portals/shared/library/box/Row.vue";

import StringUpdateRow from '@/portals/shared/cell/string/StringUpdateRow.js';
import StringUpdateCell from '@/portals/shared/cell/string/StringUpdateCell.vue';
import StringDisplayRow from '@/portals/shared/cell/string/StringDisplayRow.js';
import StringDisplayCell from '@/portals/shared/cell/string/StringDisplayCell.vue';
import CheckboxUpdateRow from '../checkbox/CheckboxUpdateRow';
import CheckboxUpdateCell from '../checkbox/CheckboxUpdateCell.vue';
import AssetRow from './AssetRow';

export default {
    name: 'asset-cell',
    components: {
        Box, Column, Row,
        StringUpdateCell,
        StringDisplayCell,
        CheckboxUpdateCell,
    },

    props: {
        showMissingRequirements: { type: Boolean, default: false },
        isAdmin: { type: Boolean, default: true },
        data: { type: Object, default: null },
    },

    data() {
        return {
            MC: new MC(),
            Connections: ConnectionUtils,
            Consts: ConstUtils,
            Content: ContentUtils,
            Strings: StringUtils,

            row: new AssetRow(),
            asset: null,
            feature: null,
            company: null,

            price: 0,
            discount: 0,

            ready: false,
            redraw: 1,
            redrawHint: 100,
        };
    },

    computed: {
    ...mapGetters([
                    'auth_connected',
                    'auth_socket_status',
                    'signin_event',
                    'auth_client',
                    'domain',
                    ]),
    },

    mounted() {
        this.row.data = this.data;
        this.asset = this.row.asset(this.domain).find();
        this.feature = this.asset.feature().find();
        this.company = this.asset.company().find();
        this.price = this.feature.price();
        this.discount = this.asset.discount();
        this.ready = true;
    },

    methods: {
    ...mapActions([
                'AuthStorage_updateCompany',
                'addListenerAction',
                'removeListenerAction',
                'updateDomain',
                ]),

    withValue(valueData) {
        if (valueData["field"] === "price") {
            if (valueData["value"] === "") {
                valueData["value"] = 0;
            }
            valueData["value"] = parseFloat(valueData["value"]);
            if (isNaN(valueData["value"])) {
                valueData["value"] = 0;
            }
            if (valueData["value"] < 0) {
                valueData["value"] = 0;
            }

            this.discount = 1 - valueData["value"] / this.feature.price();
            this.redrawHint++;
        }

        this.$emit('withValue', valueData);
    },

    withButtonPressed: function (buttonData) {
        if (StringUtils.isEmpty(buttonData["id"])) {
            buttonData["id"] = this.row.id();
        }
        buttonData["key"] = this.row.key();
        this.$emit('withButtonPressed', buttonData);
    },

    featureBox() {
        let checkbox = new CheckboxUpdateRow()
        checkbox.withName(this.row.name());
        checkbox.withDefaultValue(this.row.defaultValue());
        checkbox.withField("feature");
        checkbox.withKey(this.row.key());
        checkbox.withWidth(15)
        return checkbox;
    },

    priceRow() {
        let price = this.feature.price() - (this.feature.price() * (this.asset.discount()));
        let priceString = StringUtils.formatCurrency(price);
        let row = new StringUpdateRow();
        row.withDefaultValue(priceString);
        row.withName("Price");
        row.withKey(this.row.key());
        row.withField("price");
        return row;
    },

    hintRow() {
        let row = new StringDisplayRow();
        row.withValue("Original Price: " + StringUtils.formatCurrency(this.feature.price()) + " --- Discount: " + StringUtils.formatCurrency(this.discount * 100) + "%");
        row.withKey(this.row.key());
        row.withFontSize("small");
        row.withAlignLeft();
        row.withWidth(15);

        return row;
    }


},
}

</script>